export default __webpack_public_path__ + "static/media/member.3aefe855.png";